export default {
    props: {
        //组合题子题最小数
        minSubQquestion: {
            type: Number,
            default: 1,
        },
        //组合题子题最大数
        maxSubQquestion: {
            type: Number,
            default: 10,
        },
        //选择题选项数量
        minOptions: {
            type: Number,
            default: 2,
        },
        maxOptions: {
            type: Number,
            default: 20,
        },
        //填空数量
        minNumbers: {
            type: Number,
            default: 1,
        },
        maxNumbers: {
            type: Number,
            default: 20,
        },
        //选项字数限制  选择题和填空题字数
        inputlength: {
            type: Number,
            default: 200,
        },

        //富文本编辑器字数限制  题干、提示、解析字数
        ueditorlength: {
            type: Number,
            default: 3000,
        },

        //富文本编辑器工具栏配置
        toolBar: {
            type: Array,
            default: () => {
                return [
                    "fullscreen",
                    "bold", //粗体
                    "italic",
                    "underline", //下划线
                    "forecolor",
                    "lineheight", //行间距
                    "fontfamily", //字体
                    "fontsize", //字号
                    "customstyle", //自定义标题样式
                    "justifyleft",
                    "justifycenter",
                    "justifyright",
                    "justifyjustify",
                    "insertimage", //上传图片
                    "cleardoc", //清空文档
                    // "insertorderedlist", //有序列表    --试卷有样式问题
                    // "insertunorderedlist", //无序列表  --试卷有样式问题
                    // "simpleupload",//上传文件
                    // "inserttable", //表格
                    // "undo",
                    // "redo",
                    // "removeformat",//清除格式
                    // "formatmatch", //格式刷
                    // "pasteplain", //纯文本粘贴
                    // "backcolor",
                    // "rowspacingtop",//段前距
                    // "rowspacingbottom", //段后距
                    // "paragraph",//段落
                    // "indent", //首行缩进
                    // "selectall",//全选
                ]
            }
        },

        /* 选择题 图片上传配置 */
        //是否支持多选文件
        multiple: {
            type: Boolean,
            default: true,
        },
        //最大允许上传个数
        limitNum: {
            type: Number,
            default: 2,
        },
        //最大允许上传大小 单位M
        maxSize: {
            type: Number,
            default: 2,
        },
        //允许上传文件类型
        uploadFileExts: {
            type: String,
            default: "bpm,jpg,jpeg,png,gif",
        },
        /* 选择题 图片上传配置 */

    },
    data() {
        return {}
    },
    methods: {
        getTextLength(text) {
            var mytext = text.replace(new RegExp("&nbsp;", "g"), ""); //删除空格"&nbsp;"
            var textarr = mytext.split("<");
            var contentlength = 0;
            _.forEach(textarr, function (item) {
                var index = item.indexOf(">");
                if (item[index] !== -1) {
                    contentlength =
                        contentlength + item.substr(index + 1, item.length).length;
                }
            });
            var imgNum = this.searchTimes(text, "<img"); //图片个数
            var spaceNum = this.searchTimes(text, "&nbsp;"); //空格个数
            contentlength = contentlength + imgNum + spaceNum;
            return contentlength;
        },
    }
}
